
import { Component, Vue } from 'vue-property-decorator'
import { Getter } from 'vuex-class'
import SearchNav from '@/views/industryMall/shop/template/SearchNav.vue'
import goodsList from './components/goodsList.vue'
import storeList from './components/storeList.vue'
import { addStoreSearchHistory, getGoodsOrStoreCount } from '@/api/industryMall'

@Component({
  name: 'SearchCategoryGoods',
  components: { SearchNav, goodsList, storeList }
})
export default class SearchCategoryGoods extends Vue {
  @Getter partnerCompanyId!: string
  activeName = 'goodsList'
  params = {
    partnerCompanyId: '',
    keyword: ''
  }

  countInfo = {
    goodsCount: 0,
    storeCount: 0
  }

  created() {
    this.params.keyword = this.$route.query.keyword as string
    this.params.partnerCompanyId = this.partnerCompanyId
    this.addStoreSearchHistory()
  }

  // 产业商城搜索历史记录管理（SM）
  addStoreSearchHistory() {
    // console.log('this', this.keyword, this.partnerCompanyId)
    const data = {
      searchType: 1,
      keyword: this.params.keyword,
      storeId: this.partnerCompanyId
    }
    addStoreSearchHistory({ ...data })
    this.getGoodsOrStoreCount()
  }

  searchFunc(keyword: string) {
    this.params.keyword = keyword
    this.addStoreSearchHistory()
  }

  getGoodsOrStoreCount() {
    getGoodsOrStoreCount({ ...this.params }).then((res) => {
      if (!res.data.storeCount) {
        this.activeName = 'goodsList'
      } else if (res.data.goodsCount === 0) {
        this.activeName = 'storeList'
      }
    })
  }
}
